import { Grado } from "./tipologiche/grado";
import { MotivoScadenza } from "./tipologiche/motivo-scadenza";
import { Natura } from "./tipologiche/natura";
import { TipoAtto } from "./tipologiche/tipo-atto";
import { TipoEsito } from "./tipologiche/tipo-esito";
import { TipoFascicolo } from "./tipologiche/tipo-fascicolo";
import { TipoPratica } from "./tipologiche/tipo-pratica";
import { TipoRicorso } from "./tipologiche/tipo-ricorso.";
import { TipoScadenza } from "./tipologiche/tipo-scadenza";
import { TipoTipologica } from "./tipologiche/tipo-tipologica";

export class ScadenzarioRequest  { 
    tipoAtto: TipoAtto;
    tipoEsito: TipoEsito;
    tipoScadenza: TipoScadenza;
    motivoScadenza: MotivoScadenza;
    tipoPratica: TipoPratica;
    tipoFascicolo: TipoFascicolo;
    tipoRicorso: TipoRicorso;
    tipoData: TipoTipologica;
    grado: Grado;
    motivoAdempimento: MotivoScadenza;
    tipoAdempimento: TipoScadenza
    attore: boolean;

    constructor(pratica: TipoPratica, fascicolo: TipoFascicolo, grado: Grado, tipoAtto: TipoAtto, tipoEsito: TipoEsito, tipoScadenza: TipoScadenza, motivoScadenza: MotivoScadenza, tipoData?: TipoTipologica, adempimento?: TipoScadenza, motivoAdempimento?: MotivoScadenza, attore?: Natura, tipoRicorso?: TipoRicorso){
        this.tipoPratica = pratica ? pratica : null;
        this.tipoFascicolo = fascicolo ? fascicolo : null;
        this.grado = grado ? grado : null;
        this.tipoAtto = tipoAtto ? tipoAtto : null;
        this.tipoEsito = tipoEsito ? tipoEsito : null;
        this.tipoScadenza = tipoScadenza ? tipoScadenza : null;
        this.motivoScadenza = motivoScadenza ? motivoScadenza : null;
        this.tipoAdempimento = adempimento ? adempimento : null;
        this.motivoAdempimento = motivoAdempimento ? motivoAdempimento : null;
        this.tipoRicorso = tipoRicorso ? tipoRicorso : null;
        if(tipoData){
            this.tipoData = tipoData;
        }
        if(attore){
            this.attore = attore.label === 'ATTIVO' ? true : false;
        }

    }
}
